import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import 'hammerjs';
// Use this import for local development of your stencil-components
// import { defineCustomElements as defineCustomElementUiComponents } from '../../../../storybook/packages/core';
// Note: - your angular-os-apps and storybook -repos must be within the same parent folder
//       - don't forget to comment out the 'SewUiComponentsModule' at the import section of 'app.module.ts'
// Important: Undo those changes when before you integrate your changes into the repository!
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
